import Image from 'next/image';
import Link from 'next/link';
import { useMemo } from 'react';

import { cn } from '@app/libs/utils';

interface HotestPropertiesSectionProps {
  properties: any[];
  className?: string;
}

export const HotestPropertiesSection: React.FC<HotestPropertiesSectionProps> = ({
  properties,
  className,
}) => {
  const provinces = useMemo(() => {
    return properties.slice(0, 5);
  }, [properties]);

  const normalizeProvince = (name: string) => {
    return name
      .replace(/(Tỉnh |Thành phố )/, '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/ /g, '-')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D');
  };

  return (
    <section className={cn('w-full flex justify-center', className)}>
      <div className="2xl:w-[90rem] w-full mx-auto px-5 py-5">
        <div className="flex flex-col items-center gap-4 text-center mb-10">
          <span className="text-sm font-semibold tracking-wide uppercase text-gray-500">
            Tin đăng nổi bật
          </span>
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900">
            Bất động sản theo khu vực
          </h2>
        </div>

        {/* Cards */}
        {/* Grid gap ~30px → dùng gap-8 (~32px) */}
        <div className="grid grid-cols-1 grid-rows-5 xl:grid-cols-4 md:grid-cols-2 xl:grid-rows-2 md:grid-rows-4 gap-5 xl:h-[400px] h-[800px]">
          {provinces?.map((province, index) => (
            <Link
              href={`/properties?provinceCodes=${province.provinceCode}`}
              key={province.provinceCode}
              className={cn(
                'flex flex-col items-center justify-center relative bg-gray-900 rounded-lg overflow-hidden',
                index === 0
                  ? 'md:col-span-2 md:row-span-2 col-span-1 row-span-1'
                  : 'col-span-1 row-span-1'
              )}
            >
              <Image
                src={`/images/provinces/${normalizeProvince(province.provinceName)}.jpg`}
                alt={province.name}
                fill
                className="object-cover h-full w-full opacity-50 rounded-lg"
              />
              <span className="absolute text-sm text-white tracking-wide flex flex-col bottom-5 left-5">
                <span className="uppercase font-semibold ">{province.provinceName}</span>
                <span className="text-xs">
                  {
                    properties.find(property => property.provinceCode === province.provinceCode)
                      ?.total
                  }{' '}
                  tin đăng
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
